export default __webpack_public_path__ + "static/media/dt1.278a9320.webp";